import { authClient } from "../api/index";

export const safeGet = async (url) => {
  try {
    const res = await authClient().get(url);
    return { status: res.status, data: res.data };
  } catch (error) {
    if (error.response) {
      return {
        status: error.response.status,
        data: error.response.data,
      };
    } else {
      console.error("Error inesperado o de red:", error);
      return { status: 500, data: null };
    }
  }
}
